import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAZa1VkXoOR7WmHP7K0EYKGhMAJ-GaRUP4",
  authDomain: "ardarhayam.firebaseapp.com",
  projectId: "ardarhayam",
  storageBucket: "ardarhayam.appspot.com",
  messagingSenderId: "866225066149",
  appId: "1:866225066149:web:404fc61b1320c5144d3d4c",
  measurementId: "G-KDB8EDCLWN"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
